import { clientHttp, staffHttp, setClientToken, setStaffToken } from "./http";

// -------- CLIENT (email+password) --------
export async function loginClient(email, password) {
  const { data } = await clientHttp.post("/client/auth/login", { email, password });
  setClientToken(data.access_token);
  return data;
}

// -------- CLIENT (magic link reçu par email pour 1ère connexion) --------
export async function verifyMagicLink(email, token) {
  const { data } = await clientHttp.post("/client/auth/verify", { email, token });
  setClientToken(data.access_token);
  return data;
}

export async function getClientProfile() {
  const { data } = await clientHttp.get("/client/auth/me");
  return data;
}

export async function logoutClient() {
  try {
    await clientHttp.post("/client/auth/logout");
  } catch (_) {}
  setClientToken("");
}

// -------- STAFF (Microsoft SSO uniquement) --------
export async function getStaffProfile() {
  const { data } = await staffHttp.get("/staff/auth/me");
  return data;
}

export async function logoutStaff() {
  try {
    await staffHttp.post("/staff/auth/logout");
  } catch (_) {}
  setStaffToken("");
}

export async function refreshStaff() {
  const { data } = await staffHttp.post("/staff/auth/refresh");
  setStaffToken(data.access_token);
  return data;
}
